import { observable, action, makeObservable } from "mobx";
import { RootStore } from "./RootStore";

export interface INotificationStatus {
    name: string;
    email?: string;
    date?: string;
    state: number;
}

export class NotificationStore {
    rootStore: RootStore;
    notificationId: number | undefined;
    isNewsOrAssemblyState: number | undefined;
    notificationtype: number | undefined;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        makeObservable(this, {
            notificationId: observable,
            isNewsOrAssemblyState: observable,
            notificationtype: observable,
            setNotificationId: action,
            setIsNewsOrAssemblyState: action,
            setNotificationtype: action
        });
    }

    setNotificationId = (notificationId: number) => {
        this.notificationId = notificationId;
    };

    setIsNewsOrAssemblyState = (isNewsOrAssemblyState: number) => {
        this.isNewsOrAssemblyState = isNewsOrAssemblyState;
    };

    setNotificationtype = (notificationtype?: number) => {
        this.notificationtype = notificationtype;
    };
}
